var render = function render(){var _vm=this,_c=_vm._self._c;return _c('header',{staticClass:"container-fliud"},[_c('div',{staticClass:"header_bg text-center",style:({ backgroundImage: 'url(' + _vm.aboutUsCommon.Banner + ')' })})])
}
var staticRenderFns = []

export { render, staticRenderFns }